var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuantityDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0H12V4V8V12H8H4H0V8H4V4H8V0ZM6.15385 6.92308C6.15385 6.66818 6.36048 6.46154 6.61539 6.46154C6.87029 6.46154 7.07692 6.66818 7.07692 6.92308C7.07692 7.17798 6.87029 7.38462 6.61539 7.38462C6.36048 7.38462 6.15385 7.17798 6.15385 6.92308ZM6.61539 5.84615C6.02062 5.84615 5.53846 6.32831 5.53846 6.92308C5.53846 7.51785 6.02062 8 6.61539 8C7.21015 8 7.69231 7.51785 7.69231 6.92308C7.69231 6.32831 7.21015 5.84615 6.61539 5.84615ZM8.92308 9.69231C8.92308 9.43741 9.12971 9.23077 9.38462 9.23077C9.63952 9.23077 9.84615 9.43741 9.84615 9.69231C9.84615 9.94721 9.63952 10.1538 9.38462 10.1538C9.12971 10.1538 8.92308 9.94721 8.92308 9.69231ZM9.38462 8.61539C8.78985 8.61539 8.30769 9.09754 8.30769 9.69231C8.30769 10.2871 8.78985 10.7692 9.38462 10.7692C9.97938 10.7692 10.4615 10.2871 10.4615 9.69231C10.4615 9.09754 9.97938 8.61539 9.38462 8.61539ZM10.2813 6.46155L6.15386 10.589L5.71871 10.1539L9.84616 6.0264L10.2813 6.46155Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityDiscount);
export default __webpack_public_path__ + "static/media/quantity-discount.445c54ac2ffae270e047d6496e967c2e.svg";
export { ForwardRef as ReactComponent };